import axios from "axios";
import { getItem } from "../../features/authentication/utils/handleLocalStorage";
import { logoutUser } from "../../features/authentication/hooks/logoutUser";
import { toast } from "react-toastify";

const API_URL = import.meta.env.VITE_API_URL;

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

apiClient.interceptors.request.use(
  (config) => {
    let token = getItem("token");

    if (token) {
      // Eliminar comillas del token
      token = token.replace(/['"]+/g, '');
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, config } = error.response;
      if (status === 401) {
        toast.error("Sesión expirada o no autorizado", { autoClose: false });
        logoutUser();
      }

      if (config.url.includes("/logout")) {
        logoutUser();
      }
    }
    return Promise.reject(error);
  }
);
